/*
 * Author: Ben Zhao
 * File Created: Tuesday, 25-06-17 06:30 pm
 * Last Modified: Wednesday, 25-06-18 04:04 pm, by Ben Zhao
 */

import { get } from '@web/http';

const commonGet = (path: string, params: any) => {
  const status = (
    process.env.NEXT_PUBLIC_GRAPHQL_STATUS || 'PUBLISHED'
  ).toLocaleLowerCase();

  return get(`/cms-api${path.startsWith('/') ? path : `/${path}`}`, {
    ...params,
    status,
  });
};

export const getNotifications = async ({
  locale = 'en',
  bizType,
}: {
  locale: string;
  bizType?: string;
}) => {
  return commonGet('/decard/public/v1/get-notifications', {
    locale,
    bizType,
  });
};
